import React from "react";
export const BrowserDetectionError = {
    ie: () => <div className="alert alert-danger" role="alert">Warning: You are using an unsupported browser. This application may not work as expected. Please use a recent version of Chrome, Edge or Firefox.</div>,
    default: (browser:any) => <div></div>,
};